import request from '@/utils/request.js'
import { V3 } from '@/utils/config.js'

export function getUserInfo() {
    return request({
        url: '/'+ V3 +'/privilege',
        method: 'get',
    })
}